import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class FatigueService {

  constructor(private http: HttpClient) { }

  addCalculationForm(data) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "fatigue", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      }, () => {
        console.log("CALL COMPLETED ")
        observer.complete();
      })
    });
  }


  getCalculationForm() {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "fatigue").subscribe((res: any) => {
        console.log("Get form : ", res);
        observer.next(res.data);
      }, (err) => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  editCalculationForm(data) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "fatigue", data).subscribe((res: any) => {
        console.log("Edited form : ", res);
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

}